module.exports = __webpack_public_path__ + "img/home-imagen.1b1f5bcb.png";